import React, { useContext, useRef } from "react";

// plugin
import { Link, useTranslation } from "@herob191/gatsby-plugin-react-i18next";
import { AnimatePresence, motion } from "motion/react";

// style
import "./navBar.scss";

// context
import { LayoutContext } from "../../../../context/layoutContext";

// component
import MenuBody from "../menuBody/menuBody";
import FlashHover from "../../../flashHover/flashHover";

// util
import useElementSize from "../../../../util/resizeObserver";
import { animationStates } from "../../../../util/motionAnimations";

// svg
import Logo from "../../../../svg/logotype.svg";
import NavProject from "../navProject/navProject";

// component

export default function NavBar() {
	const { t } = useTranslation();

	const { menuOpen, setMenuOpen, projectOpen, setProjectOpen } =
		useContext(LayoutContext);
	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};
	// useEffect(() => {
	// 	if (typeof document !== undefined && typeof window !== undefined) {
	// 		if (menuOpen) {
	// 			// We want a fixed body;
	// 			document.body.style.top = `-${window.scrollY}px`;
	// 			document.body.style.position = "fixed";
	// 			document.body.style.overflowY = "scroll";
	// 			document.documentElement.style.scrollBehavior = "auto";
	// 		} else {
	// 			const scrollY = document.body.style.top;
	// 			const windowScroll = `-${window.scrollY}px`;
	// 			// console.log(scrollY);
	// 			// console.log(windowScroll);
	// 			document.body.style.position = "";
	// 			document.body.style.top = "";
	// 			window.scrollTo(0, parseInt(scrollY || windowScroll || "0") * -1);
	// 			document.documentElement.style.scrollBehavior = "";
	// 		}
	// 	}
	// }, [menuOpen]);

	const navBarTopRef = useRef(null);
	const navBarSize = useElementSize(navBarTopRef);
	const navMenuBodyRef = useRef(null);
	const navMenuBodySize = useElementSize(navMenuBodyRef);

	return (
		<div className="navBarWrapper">
			<AnimatePresence>
				{menuOpen && (
					<motion.button
						{...animationStates}
						variants={{
							initial: {
								opacity: 0,
							},
							animate: {
								opacity: 1,
							},
							exit: {
								opacity: 0,
								transition: {
									delay: 0.4,
								},
							},
						}}
						onClick={() => setMenuOpen(false)}
						className="outsideClickBg"
						aria-label={menuOpen ? t("Cerrar menú") : t("Abrir menú")}
					/>
				)}
			</AnimatePresence>

			<motion.nav
				className={`navBar ${projectOpen ? "widen" : ""}`}
				initial={{
					borderColor: "rgba(248, 248, 248, 0)",
					height: 0,
				}}
				animate={{
					borderColor: "rgba(248, 248, 248, 0.35)",
					height: menuOpen
						? navBarSize.height + navMenuBodySize.height
						: navBarSize.height,
				}}
				transition={{
					duration: 0.6,
					ease: [0.6, -0.05, 0, 1.05],
					borderColor: {
						delay: 1,
					},
				}}
			>
				<div className="navBarBgs">
					<div className="navBarBlurBg" />
					<div className={`navBarGradient1Bg ${menuOpen ? "move" : ""}`} />
					<div className={`navBarGradient2Bg ${menuOpen ? "move" : ""}`} />
					<div className={`navBarGradient3Bg ${menuOpen ? "move" : ""}`} />
					<div className="navBarNoiseBg" />
				</div>

				<div className="navBarTop" ref={navBarTopRef}>
					{/* <FlashHover> */}
					<Link
						to="/"
						className="navLogo"
						onClick={() => {
							setMenuOpen(false);
							setProjectOpen(null);
						}}
					>
						<Logo className="navLogo" />
					</Link>
					{/* </FlashHover> */}

					<FlashHover>
						<button
							className={`menuButton ${menuOpen ? "cross" : ""}`}
							aria-label={menuOpen ? t("Cerrar menú") : t("Abrir menú")}
							aria-expanded={menuOpen}
							onClick={toggleMenu}
						>
							<span />
							<span />
							<span />
						</button>
					</FlashHover>

					<NavProject />
				</div>
				<MenuBody key="menuBody" ref={navMenuBodyRef} />
			</motion.nav>
		</div>
	);
}
